var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"targetEl",tag:"component",style:(_vm.tag === 'div' ? ("min-height:" + (_vm.fixedMinHeight ? _vm.fixedMinHeight : _vm.minHeight) + "px") : null)},[(_vm.shouldRender)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }